import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface PaymentOptionProps {
  /** Brend logosi (rasmiy mark) — 24–28px */
  logo: ReactNode;
  name: string;
  selected: boolean;
  onSelect: () => void;
  disabled?: boolean;
  /** Disabled holatda ko'rsatiladigan matn (mas. "Tez orada") */
  hint?: string;
  /** Tanlangan radio rangi (Click ko'k bo'lishi mumkin). Default brand accent. */
  accent?: string;
}

/**
 * To'lov usuli qatori — Figma §5.10.
 * Oq karta ichida dividerlar bilan guruhlanadi (screen Card + divider beradi).
 */
export function PaymentOption({
  logo,
  name,
  selected,
  onSelect,
  disabled = false,
  hint,
  accent = "var(--primary)",
}: PaymentOptionProps) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      disabled={disabled}
      onClick={onSelect}
      className={cn(
        "flex w-full items-center gap-3 px-4 py-3.5 text-left transition-colors",
        disabled ? "cursor-not-allowed opacity-60" : "active:bg-[var(--c-line)]",
      )}
    >
      <span className="grid size-7 shrink-0 place-items-center">{logo}</span>
      <span className="flex-1 text-base font-semibold" style={{ color: "var(--c-text)" }}>
        {name}
      </span>
      {disabled && hint && (
        <span className="text-sm" style={{ color: "var(--c-text-muted)" }}>
          {hint}
        </span>
      )}
      {/* Radio 20px */}
      <span
        className="grid size-5 shrink-0 place-items-center rounded-full"
        style={{
          boxShadow: selected ? `inset 0 0 0 2px ${accent}` : "inset 0 0 0 2px var(--c-text-disabled)",
        }}
        aria-hidden
      >
        {selected && <span className="size-2.5 rounded-full" style={{ background: accent }} />}
      </span>
    </button>
  );
}
